import { useState, useEffect } from "react"
import { getProjectList } from "services/projectsService"

export default function useProjects() {
  const [projects, setProjects] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const data = getProjectList()

    setProjects(data.items || [])
    setIsLoading(false)
  }, [])

  return { projects, isLoading }
}
